var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "mix-clickable": _vm.isMixEnabled && _vm.damageId },
      attrs: { id: "mix-clickable-cell" }
    },
    [
      _c(
        "div",
        { class: { active: _vm.selected }, on: { click: _vm.handleOnClick } },
        [_vm._t("cellContent")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }